// Vendor imports
const ReactRedux = require('react-redux')

// React Hooks

/**
 * @param {string} rolloutKey
 * @returns {boolean}
 */
function useRollout(rolloutKey) {
  return ReactRedux.useSelector(state => state.user.hasRollout(rolloutKey))
}

/**
 * @param {string} experimentKey
 * @returns {string|void}
 */
function useExperiment(experimentKey) {
  return ReactRedux.useSelector(state => state.user.getExperiment(experimentKey))
}

// React Components

/**
 * @deprecated In favor of the `useRollout` hook
 * @param {Object} options
 * @param {string} options.rolloutKey
 * @param {() => React.ElementType} [options.renderIncluded]
 * @param {() => React.ElementType} [options.renderExcluded]
 * @returns {React.ElementType}
 */
function CheckRollout({ rolloutKey, renderIncluded, renderExcluded }) {
  const isIncluded = useRollout(rolloutKey)
  if (isIncluded) {
    return renderIncluded()
  }
  return renderExcluded ? renderExcluded() : null
}

/**
 * @deprecated In favor of the `useExperiment` hook
 * @param {Object} options
 * @param {string} options.experimentKey
 * @param {Object.<string, () => React.ElementType>} [options.renderByModifier]
 * @param {(modifier: string) => React.ElementType} [options.renderWithModifier]
 * @returns {React.ElementType}
 */
function CheckExperiment({ experimentKey, renderByModifier, renderWithModifier }) {
  const modifier = useExperiment(experimentKey)
  // Prefer modifier-specific render functions (when specified)
  if (renderByModifier) {
    if (modifier && renderByModifier[modifier]) {
      return renderByModifier[modifier]()
    }
    // Fall-back to the "control" modifier if no other render function applies
    if (renderByModifier.control) {
      return renderByModifier.control()
    }
  }
  if (renderWithModifier) {
    return renderWithModifier(modifier)
  }
  return null
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')

  CheckRollout.propTypes = {
    // Values
    rolloutKey: PropTypes.string.isRequired,
    // Render props
    renderExcluded: PropTypes.func,
    renderIncluded: PropTypes.func.isRequired
  }

  CheckExperiment.propTypes = {
    // Values
    experimentKey: PropTypes.string.isRequired,
    // Render props
    renderByModifier: PropTypes.objectOf(PropTypes.func),
    renderWithModifier: PropTypes.func
  }
}

module.exports = {
  // React Hooks
  useRollout,
  useExperiment,
  // React Components
  CheckRollout,
  CheckExperiment
}
